import { gql } from "@apollo/client";
import { groupDetailsListItemV2Fragment } from "../fragments";

export const getGroupListV2 = gql`
    query getGroupListV2($limit: Int!, $offset: Int!, $organizationId: String = null, $lensLimit: Int = 20) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getGroupListV2(
            input: {
                limit: $limit
                offset: $offset
                lensLimit: $lensLimit
                query: ONLY_ACTIVE
                organizationId: $organizationId
            }
        ) {
            groupsWithConnections {
                ...GroupDetailsListItemV2
            }
        }
    }
    ${groupDetailsListItemV2Fragment}
`;

export const getGroupListV2WithCursor = gql`
    query GetGroupListV2WithCursor(
        $limit: Int!
        $cursor: String = null
        $organizationId: String = null
        $lensLimit: Int = 20
    ) {
        getGroupListV2(
            input: {
                limit: $limit
                cursor: $cursor
                lensLimit: $lensLimit
                query: ONLY_ACTIVE
                organizationId: $organizationId
            }
        ) @connection(key: "getGroupListV2WithCursor") {
            groupsWithConnections {
                ...GroupDetailsListItemV2
            }
            cursor
            hasMore
        }
    }
    ${groupDetailsListItemV2Fragment}
`;

export const getCachedGroupListV2 = gql`
    query getCachedGroupListV2 {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getGroupListV2(input: { limit: 0, offset: 0, lensLimit: 0, organizationId: null }) {
            groupsWithConnections {
                ...GroupDetailsListItemV2
            }
        }
    }
    ${groupDetailsListItemV2Fragment}
`;
